import React, { Component } from 'react'
import LoanTypeAndEventMappingEditModalUI from './LoanTypeAndEventMappingEditModalUI'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class LoanTypeAndEventMappingEditModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      whatsappTemplateId: '',
      emailTemplateId: '',
      positiveWhatsappTemplateId: '',
      negativeWhatsappTemplateId: '',
      positiveEmailTemplateId: '',
      negativeEmailTemplateId: '',
      status: '',
      isEnabled: false,
      sequence: 1,
      
      whatsappTemplateIdError: null,
      emailTemplateIdError: null,
      positiveWhatsappTemplateIdError: null,
      negativeWhatsappTemplateIdError: null,
      positiveEmailTemplateIdError: null,
      negativeEmailTemplateIdError: null,
      statusError: null,
      
      successMsg: null,
      errorList: [],
      submitted: false,
      
      // Templates
      whatsappTemplates: [],
      emailTemplates: [],
      loadingTemplates: false,
      loadingEmailTemplates: false
    }
  }

  componentDidMount() {
    // Fetch templates when component mounts
    this.fetchWhatsappTemplates()
    this.fetchEmailTemplates()
  }

  fetchWhatsappTemplates = () => {
    this.setState({ loadingTemplates: true })
    RestApiUtils.get(this.props.context, '/api/su/whatsappTemplates/all', this.handleWhatsappTemplatesResponse)
  }

  handleWhatsappTemplatesResponse = (data) => {
    if (data && data.templates && Array.isArray(data.templates)) {
      this.setState({
        whatsappTemplates: data.templates,
        loadingTemplates: false
      })
    } else {
      this.setState({
        whatsappTemplates: [],
        loadingTemplates: false
      })
      console.error('Failed to fetch WhatsApp templates or empty response')
    }
  }

  fetchEmailTemplates = () => {
    this.setState({ loadingEmailTemplates: true })
    RestApiUtils.get(this.props.context, '/api/su/emailTemplates/emailTemplateList', this.handleEmailTemplatesResponse)
  }

  handleEmailTemplatesResponse = (data) => {
    if (data && data.templates && Array.isArray(data.templates)) {
      this.setState({
        emailTemplates: data.templates,
        loadingEmailTemplates: false
      })
    } else {
      this.setState({
        emailTemplates: [],
        loadingEmailTemplates: false
      })
      console.error('Failed to fetch email templates or empty response')
    }
  }

  componentDidUpdate(prevProps) {
    // Initialize form when modal opens with selected mapping data
    if (this.props.editMode && !prevProps.editMode && this.props.selectedMapping) {
      const { 
        whatsappTemplateId,
        emailTemplateId,
        positiveWhatsappTemplateId,
        negativeWhatsappTemplateId,
        positiveEmailTemplateId,
        negativeEmailTemplateId,
        status,
        isEnabled,
        sequence
      } = this.props.selectedMapping
      
      this.setState({
        whatsappTemplateId: whatsappTemplateId || '',
        emailTemplateId: emailTemplateId || '',
        positiveWhatsappTemplateId: positiveWhatsappTemplateId || '',
        negativeWhatsappTemplateId: negativeWhatsappTemplateId || '',
        positiveEmailTemplateId: positiveEmailTemplateId || '',
        negativeEmailTemplateId: negativeEmailTemplateId || '',
        status: status || '',
        isEnabled: isEnabled || false,
        sequence: sequence || 1,
        
        whatsappTemplateIdError: null,
        emailTemplateIdError: null,
        positiveWhatsappTemplateIdError: null,
        negativeWhatsappTemplateIdError: null,
        positiveEmailTemplateIdError: null,
        negativeEmailTemplateIdError: null,
        statusError: null,
        
        successMsg: null,
        errorList: [],
        submitted: false
      })
    }
  }

  handleWhatsappTemplateIdChange = (e) => {
    this.setState({ 
      whatsappTemplateId: e.target.value,
      whatsappTemplateIdError: null 
    })
  }

  handleEmailTemplateIdChange = (e) => {
    this.setState({ 
      emailTemplateId: e.target.value,
      emailTemplateIdError: null 
    })
  }

  handlePositiveWhatsappTemplateIdChange = (e) => {
    this.setState({ 
      positiveWhatsappTemplateId: e.target.value,
      positiveWhatsappTemplateIdError: null 
    })
  }

  handleNegativeWhatsappTemplateIdChange = (e) => {
    this.setState({ 
      negativeWhatsappTemplateId: e.target.value,
      negativeWhatsappTemplateIdError: null 
    })
  }

  handlePositiveEmailTemplateIdChange = (e) => {
    this.setState({ 
      positiveEmailTemplateId: e.target.value,
      positiveEmailTemplateIdError: null 
    })
  }

  handleNegativeEmailTemplateIdChange = (e) => {
    this.setState({ 
      negativeEmailTemplateId: e.target.value,
      negativeEmailTemplateIdError: null 
    })
  }

  handleStatusChange = (e) => {
    this.setState({ 
      status: e.target.value,
      statusError: null 
    })
  }

  handleMapEventChange = (isEnabled) => {
    this.setState({ isEnabled: isEnabled });
  }

  validateForm = () => {
    let isValid = true
    
    if (!this.state.whatsappTemplateId) {
      this.setState({ whatsappTemplateIdError: 'WhatsApp Template ID is required' })
      isValid = false
    }
    
    if (!this.state.emailTemplateId) {
      this.setState({ emailTemplateIdError: 'Email Template ID is required' })
      isValid = false
    }
    
    if (!this.state.positiveWhatsappTemplateId) {
      this.setState({ positiveWhatsappTemplateIdError: 'Positive WhatsApp Template ID is required' })
      isValid = false
    }
    
    if (!this.state.negativeWhatsappTemplateId) {
      this.setState({ negativeWhatsappTemplateIdError: 'Negative WhatsApp Template ID is required' })
      isValid = false
    }
    
    if (!this.state.positiveEmailTemplateId) {
      this.setState({ positiveEmailTemplateIdError: 'Positive Email Template ID is required' })
      isValid = false
    }
    
    if (!this.state.negativeEmailTemplateId) {
      this.setState({ negativeEmailTemplateIdError: 'Negative Email Template ID is required' })
      isValid = false
    }
    
    if (!this.state.status) {
      this.setState({ statusError: 'Status is required' })
      isValid = false
    }
    
    return isValid
  }

  handleSubmit = async (e) => {
    e.preventDefault()
    
    if (!this.validateForm()) {
      return
    }
    
    this.setState({ submitted: true, errorList: [] })
    
    try {
      // Extract necessary data from the selected mapping
      const { loanType, subType, id: eventId } = this.props.selectedMapping
      
      if (!loanType || !subType || !eventId) {
        throw new Error('Missing required mapping information (loanType, subType, or eventId)')
      }
      
      // Construct the API endpoint
      const endpoint = `/api/notifyLoanEventMappings/updateNotifyLoanEventMapping/${encodeURIComponent(loanType)}/${encodeURIComponent(subType)}/${encodeURIComponent(eventId)}`
      
      // Format data for API request body
      const requestBody = {
        isEnabled: this.state.isEnabled,
        sequence: parseInt(this.state.sequence || 1),
        whatsappTemplateId: this.state.whatsappTemplateId || '',
        emailTemplateId: this.state.emailTemplateId || '',
        positiveWhatsappAckTemplateId: this.state.positiveWhatsappTemplateId || '',
        negativeWhatsappAckTemplateId: this.state.negativeWhatsappTemplateId || '',
        positiveEmailAckTemplateId: this.state.positiveEmailTemplateId || '',
        negativeEmailAckTemplateId: this.state.negativeEmailTemplateId || ''
      }
      
      console.log('Request body for update:', requestBody)
      
      // Call the update API
      RestApiUtils.put(this.props.context, endpoint, this.handleUpdateResponse, requestBody )
    } catch (error) {
      console.error('Error in handleSubmit:', error)
      this.setState({ 
        errorList: [error.message || 'Failed to update mapping. Please try again.'],
        submitted: false
      })
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList })
  }
  
  setWhatsappTemplateIdError = (error) => {
    this.setState({ whatsappTemplateIdError: error })
  }
  
  setEmailTemplateIdError = (error) => {
    this.setState({ emailTemplateIdError: error })
  }
  
  setPositiveWhatsappTemplateIdError = (error) => {
    this.setState({ positiveWhatsappTemplateIdError: error })
  }
  
  setNegativeWhatsappTemplateIdError = (error) => {
    this.setState({ negativeWhatsappTemplateIdError: error })
  }
  
  setPositiveEmailTemplateIdError = (error) => {
    this.setState({ positiveEmailTemplateIdError: error })
  }
  
  setNegativeEmailTemplateIdError = (error) => {
    this.setState({ negativeEmailTemplateIdError: error })
  }
  
  setStatusError = (error) => {
    this.setState({ statusError: error })
  }

  handleUpdateResponse = (response) => {
    console.log('Response from update API:', response)
    if (response && response.success) {
      // Call the onMappingUpdated callback to update the parent component
      this.props.onMappingUpdated({
        ...this.props.selectedMapping,
        whatsappTemplateId: this.state.whatsappTemplateId,
        emailTemplateId: this.state.emailTemplateId,
        positiveWhatsappTemplateId: this.state.positiveWhatsappTemplateId,
        negativeWhatsappTemplateId: this.state.negativeWhatsappTemplateId,
        positiveEmailTemplateId: this.state.positiveEmailTemplateId,
        negativeEmailTemplateId: this.state.negativeEmailTemplateId,
        status: this.state.status,
        isEnabled: this.state.isEnabled,
        sequence: this.state.sequence
      })
      
      this.setState({ 
        successMsg: 'Mapping updated successfully',
        submitted: false
      })
      
      // Close modal after a short delay
      setTimeout(() => {
        this.props.onCancel()
      }, 1000)
    } else {
      const errorMessage = response && response.errorList && response.errorList.length > 0 
        ? response.errorList.join(', ') 
        : 'Failed to update mapping. Please try again.'
      
      this.setState({ 
        errorList: [errorMessage],
        submitted: false
      })
    }
  }
  
  handleUpdateError = (error) => {
    console.error('API Error:', error)
    this.setState({ 
      errorList: ['Failed to update mapping. Please try again.'],
      submitted: false
    })
  }

  handleSequenceChange = (sequence) => {
    console.log('Sequence changed to:', parseInt(sequence))
    this.setState({sequence: parseInt(sequence) || 1 })
  }

  render() {
    const { messageList = [] } = this.props;
    
    return (
      <LoanTypeAndEventMappingEditModalUI
        context={this.props.context}
        messageList={this.props.messageList}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={this.setErrorList}
        
        editMode={this.props.editMode}
        submitted={this.state.submitted}
        
        whatsappTemplateId={this.state.whatsappTemplateId}
        onWhatsappTemplateIdChange={this.handleWhatsappTemplateIdChange}
        whatsappTemplateIdError={this.state.whatsappTemplateIdError}
        setWhatsappTemplateIdError={this.setWhatsappTemplateIdError}
        
        emailTemplateId={this.state.emailTemplateId}
        onEmailTemplateIdChange={this.handleEmailTemplateIdChange}
        emailTemplateIdError={this.state.emailTemplateIdError}
        setEmailTemplateIdError={this.setEmailTemplateIdError}
        
        positiveWhatsappTemplateId={this.state.positiveWhatsappTemplateId}
        onPositiveWhatsappTemplateIdChange={this.handlePositiveWhatsappTemplateIdChange}
        positiveWhatsappTemplateIdError={this.state.positiveWhatsappTemplateIdError}
        setPositiveWhatsappTemplateIdError={this.setPositiveWhatsappTemplateIdError}
        
        negativeWhatsappTemplateId={this.state.negativeWhatsappTemplateId}
        onNegativeWhatsappTemplateIdChange={this.handleNegativeWhatsappTemplateIdChange}
        negativeWhatsappTemplateIdError={this.state.negativeWhatsappTemplateIdError}
        setNegativeWhatsappTemplateIdError={this.setNegativeWhatsappTemplateIdError}
        
        positiveEmailTemplateId={this.state.positiveEmailTemplateId}
        onPositiveEmailTemplateIdChange={this.handlePositiveEmailTemplateIdChange}
        positiveEmailTemplateIdError={this.state.positiveEmailTemplateIdError}
        setPositiveEmailTemplateIdError={this.setPositiveEmailTemplateIdError}
        
        negativeEmailTemplateId={this.state.negativeEmailTemplateId}
        onNegativeEmailTemplateIdChange={this.handleNegativeEmailTemplateIdChange}
        negativeEmailTemplateIdError={this.state.negativeEmailTemplateIdError}
        setNegativeEmailTemplateIdError={this.setNegativeEmailTemplateIdError}
        
        status={this.state.status}
        onStatusChange={this.handleStatusChange}
        statusError={this.state.statusError}
        setStatusError={this.setStatusError}
        
        isEnabled={this.state.isEnabled}
        onMapEventChange={this.handleMapEventChange}
        
        sequence={this.state.sequence}
        onSequenceChange={this.handleSequenceChange}
        
        onSubmit={this.handleSubmit}
        onCancelClick={this.props.onCancel}
        
        // Templates
        whatsappTemplates={this.state.whatsappTemplates}
        emailTemplates={this.state.emailTemplates}
        loadingTemplates={this.state.loadingTemplates}
        loadingEmailTemplates={this.state.loadingEmailTemplates}
      />
    );
  }
}

export default LoanTypeAndEventMappingEditModalSF;
